import { jsx as r } from "react/jsx-runtime";
import d from "classnames";
import l from "../../utils/colors.js";
import { b as p } from "../../styled-qu50FBLM.mjs";
import { Svg as c, GElement as e, Polygon as f } from "./Elements.js";
const u = ({
  className: t = "",
  fill: o = l.green,
  width: n = 161,
  height: i = 122,
  polygonPoints: a = "51.2272727 96.5074627 12.8068182 58.2686567 0 71.0149254 51.2272727 122 161 12.7462687 148.193182 1.04591891e-10",
  $cssHelper: m = p,
  focusable: s = !1
}) => /* @__PURE__ */ r(
  c,
  {
    className: d({ [t]: !!t }),
    viewBox: `0 0 ${n} ${i}`,
    width: `${n}px`,
    height: `${i}px`,
    $cssHelper: m,
    fill: o,
    focusable: !!s,
    "aria-hidden": !s,
    children: /* @__PURE__ */ r(e, { stroke: "none", strokeWidth: "1", fill: o, fillRule: "evenodd", children: /* @__PURE__ */ r(e, { transform: "translate(-109.000000, -489.000000)", fill: o, children: /* @__PURE__ */ r(e, { transform: "translate(109.000000, 489.000000)", fill: o, children: /* @__PURE__ */ r(f, { points: a }) }) }) })
  }
);
export {
  u as default
};
